import React from 'react';
import { StyledCheckbox, StyledCard, StyledTitle } from './styled';
import ActionButton from './ActionButton';
import { AVAILABILITY, SINGLE_SELECT, MULTI_SELECT } from '../config/constants';
import { Image } from 'antd';

const DrawerCard = ({ data, addedWidgetsLength }) => {
  const limit = data.meta.limit;
  const selectType = limit > 1 ? MULTI_SELECT : SINGLE_SELECT;
  const meta = data.meta;

  const renderCardTitle = () => {
    if (meta.availability && meta.availability !== AVAILABILITY.GA) {
      return (
        <StyledTitle>
          <span className="title">{meta.title}</span>
          <sup>{AVAILABILITY[meta.availability]}</sup>
        </StyledTitle>
      );
    }
    return meta.title;
  };

  return (
    <StyledCheckbox>
      <StyledCard
        size="small"
        title={renderCardTitle()}
        variant="borderless"
        extra={
          <ActionButton
            type={data.type}
            select={selectType}
            localLimit={limit}
            addedWidgetsCount={addedWidgetsLength}
          />
        }
      >
        {data.meta.preview ? (
          <Image preview={false} src={data.meta.preview} />
        ) : (
          'Preview Unavailable'
        )}
      </StyledCard>
    </StyledCheckbox>
  );
};

export default DrawerCard;
